import PropTypes from 'prop-types';
import { AGENT, DEFAULT, VISITOR } from '../constants/messageUses';
export default PropTypes.oneOf([DEFAULT, AGENT, VISITOR]);